import { render, staticRenderFns } from "./BossPayList.vue?vue&type=template&id=cff120c8&"
import script from "./BossPayList.vue?vue&type=script&lang=ts&"
export * from "./BossPayList.vue?vue&type=script&lang=ts&"
import style0 from "./BossPayList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports